import React, { createRef, useEffect, useRef } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import * as Icons from "Components/Icons";
import { Button, Col } from "Components/ReactstrapSlim";
import { HeaderSearch } from "./HeaderSearch";
import { KnownSearchAutocomplete } from "Models/Search";

const rootId = "EnterpriseManagementNavBar";
const searchElementRootId = "address";

declare module "react-bootstrap-typeahead" {
   export const Input: any;
}

export const enum CollapsibleSearchMode {
   Collapsed,
   Expanded
}
interface CollapsibleSearchProps {
   className?: string;
   mode: CollapsibleSearchMode;
   onModeChange: (mode: CollapsibleSearchMode) => void;
}
export const CollapsibleSearch: React.FC<CollapsibleSearchProps> = ({ className, mode, onModeChange }) => {
   const typeaheadRef = useRef<AsyncTypeahead<KnownSearchAutocomplete>>();
   const headerSearchRef = createRef<HTMLFormElement>();
   
   function expand() {
      onModeChange(CollapsibleSearchMode.Expanded);
   }
   function collapse() {
      typeaheadRef.current?.clear();
      onModeChange(CollapsibleSearchMode.Collapsed);
   }

   useEffect(() => {
      if (mode == CollapsibleSearchMode.Expanded) {
         requestAnimationFrame(() => typeaheadRef.current?.focus());
      }
   }, [mode])

   useEffect(() => {
      function handleClickOutside(event: PointerEvent) {
         const root = document.getElementById(rootId);
         if (event.target == root && event.composedPath().find((el) => { return (el as HTMLElement).id == searchElementRootId })) {
            //do not collapse is this case C16688
         }
         else if (headerSearchRef.current && !headerSearchRef.current.contains(event.target as any)) {
            collapse();
         }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
         document.removeEventListener("mousedown", handleClickOutside);
      };
   }, []);


   return <>
      <HeaderSearch
         ref={headerSearchRef}
         typeaheadRef={typeaheadRef}
         ariaLabel="close"
         className="col header-search header-search-collapsible"
         elementRootContainerId={searchElementRootId}
         onButtonClick={e => { e.preventDefault(); collapse(); }}
         buttonContent={() => <Icons.Close />} />
      <Col className="col-auto header-search-find">
         <Button className="rounded-pill" color="transparent" size="sm" onClick={expand} aria-label="find">
            <Icons.Find />
         </Button>
      </Col>
   </>;
}